import styles from "../css/SetupModal.module.css";

export default function SetupModal({ children, onClose }) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.content}>
          {children} 
          <button onClick={onClose} className={styles.closeButton}>
            x
          </button>
        </div>
      </div>
    </div>
  );
}
